import { useMutation } from '@tanstack/react-query';
import { documentApiClient } from 'src/api/FiretrolApiClientInstances';
import { triggerDownload } from 'src/utils';

/** @registry Downloads a job document to the browser. */
export function useDownloadDocument() {
  return useMutation({
    mutationFn: async ({
      jobId,
      documentId,
    }: {
      jobId: number;
      documentId: string;
    }) => {
      const result = await documentApiClient.downloadDocument(
        jobId,
        documentId,
      );
      triggerDownload(result.url, result.name);
      return result;
    },
    meta: { errorContext: 'download document' },
  });
}

/** @registry Downloads one version of a job document; `isCurrentDocument` picks the live document rather than an archived version. */
export function useDownloadDocumentVersion() {
  return useMutation({
    mutationFn: async ({
      jobId,
      versionId,
      isCurrentDocument = false,
    }: {
      jobId: number;
      versionId: string;
      isCurrentDocument?: boolean;
    }) => {
      const result = isCurrentDocument
        ? await documentApiClient.downloadDocument(jobId, versionId)
        : await documentApiClient.downloadVersionDocument(jobId, versionId);
      triggerDownload(result.url, result.name);
      return result;
    },
    meta: { errorContext: 'download document version' },
  });
}
